import { render, staticRenderFns } from "./lp-investor.vue?vue&type=template&id=02a74127&scoped=true"
import script from "./lp-investor.vue?vue&type=script&lang=js"
export * from "./lp-investor.vue?vue&type=script&lang=js"
import style0 from "./lp-investor.vue?vue&type=style&index=0&id=02a74127&prod&scoped=true&lang=css"
import style1 from "./lp-investor.vue?vue&type=style&index=1&id=02a74127&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a74127",
  null
  
)

export default component.exports